import React from 'react'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
    const pages = [
        {
            label: "GitHub",
            icon: <GitHubIcon />,
            link: "https://github.com/lucaasrojas"
        },
        {
            label: "LinkedIn",
            icon: <LinkedInIcon />,
            link: "https://www.linkedin.com/in/lucaasrojas/"
        },
    ];

    return (
        <Grid container style={{ height: 64, backgroundColor: "rgba(145, 145, 145, 0.3)" }}>
            <Grid item container xs={12} style={{ placeContent: "center" }}>
                {
                    pages.map(page => (
                        <Grid item style={{ margin: "0 8px" }}>
                            <Link href={page.link} target="_blank" rel="noreferrer">{page.icon}</Link>
                        </Grid>
                    ))
                }
            </Grid>
        </Grid>
    )
}

export default Footer